import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Modal from 'react-bootstrap/Modal'
import QRCode from "react-qr-code";
import { CouponPosFetchAPI } from '../../../api/Paymentpost/Coupon';
import { DiscountPosFetchAPI } from '../../../api/Paymentpost/Discount';
import ErrorAlert from '../../Alerts/ErrorAlert';
import { FaTicketAlt } from 'react-icons/fa';
import Socket from '../../utils/Socket.config';
import { preserveKitchenStateFromSource } from '../../../utils/PreOrderPaymentPrint';

import './ModalCoupons.css'


function ModalCoupons({ actvPlus, actvLite, shoppingCart, shoppingCartCombos, total, subtotal, itbms, discount, setLoad, setShoppingCart, taxesArrayAll }) {
   let title_modal = "Cupones "
   const [show, setShow] = useState(false);
   let { business_code, branchoffice_code } = useParams();
   const [valueInput, setValueInput] = useState("");
   const [orderCuponTemp, setOrderCuponTemp] = useState({})
   const [session, setSession] = useState(0);
   let machine = JSON.parse(localStorage.getItem('machine'))
   let token = localStorage.getItem('x-access-machine-token');


   function getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
   }


   //
   const auhtCupon = async (code) => {
      console.log(code);
      let token = localStorage.getItem('x-access-machine-token');
      let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      try {
         const response = await CouponPosFetchAPI.getCupon(code, token)

         let branchofficeArray = response.data.data.branchoffice;
         var data_filter = branchofficeArray.filter(element => element.code == branchoffice.code)
         console.log(data_filter);
         if (data_filter.length > 0) {
            console.log("El cupon si es valido");
            createTempDiscountCupon(code)
         } else {
            let icon = "warning"
            let title = "Cupon denegado."
            let message = "El cupon no es valido en esta sucursal"
            ErrorAlert(message, title, icon)
         }

      } catch (err) {
         ErrorAlert('', 'Error no se puedo aplicar el cupon', 'error')
         console.log(err);

      }
   }

   //create orders temporal of discount type cupon
   const createTempDiscountCupon = async (code) => {
      let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      let machine = JSON.parse(localStorage.getItem('machine'))
      let token = localStorage.getItem('x-access-machine-token');
      let jsonDiscountTemp = {
         "client_name": "0",
         "cupon_code": code,
         "is_cupon": true,
         "localizador": "0",
         "client_phone": "0",
         "dgi_qr": "0",
         "Orden": shoppingCart,
         "combos": shoppingCartCombos,
         "Descuento": "0",
         "Total": total,
         "itbms": itbms,
         "taxes": taxesArrayAll,
         "subtotal": subtotal,
         "machine_id": machine.id,
         "branchoffice_id": branchoffice.id,
         "tipoOrden": "comer aqui",
         "paymethod": 0,
         "is_discount_notification": true
      }
      try {
         const response = await DiscountPosFetchAPI.createTempDiscount(jsonDiscountTemp, token)
         if (response.data.message == 'Tempral order created') {
            getOrdersTempDiscount()
         }
      } catch (err) {
         ErrorAlert('', 'Error no se puedo aplicar el cupon', 'error')
         console.log(err);
      }
   }

   // get order temporal discount
   const getOrdersTempDiscount = async () => {
      let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      let machine = JSON.parse(localStorage.getItem('machine'))
      let business = JSON.parse(localStorage.getItem('business'))

      let token = localStorage.getItem('x-access-machine-token');
      try {
         const response = await DiscountPosFetchAPI.getTempDiscount(machine.code, business.code, branchoffice.code, token)

         let code = response.data.order.code
         let message = "Descuento aplicado con exito."
         let title = "Operacion exitosa"
         let icon = "success"

         let tempOrderDiscount = preserveKitchenStateFromSource(response.data.order.groups, shoppingCart)

         setOrderCuponTemp(response.data.order);
         console.log(response.data.order);
         //format json 
         for (let i = 0; i < tempOrderDiscount.length; i++) {
            for (let s = 0; s < tempOrderDiscount[i].segments.length; s++) {
               tempOrderDiscount[i].segments[s].item_id = tempOrderDiscount[i].segments[s].item.item_id
               tempOrderDiscount[i].segments[s].name = tempOrderDiscount[i].segments[s].item.name
               tempOrderDiscount[i].segments[s].cantidadItem = tempOrderDiscount[i].segments[s].item.amount
               tempOrderDiscount[i].segments[s].description = tempOrderDiscount[i].segments[s].item.description
               tempOrderDiscount[i].segments[s].img = tempOrderDiscount[i].segments[s].item.img
            }
            tempOrderDiscount[i].DetalleSegmentos = tempOrderDiscount[i].segments
            tempOrderDiscount[i].cantidadItem = tempOrderDiscount[i].amount
            tempOrderDiscount[i].descuento = tempOrderDiscount[i].discount
         }

         setShoppingCart(tempOrderDiscount)
         setLoad(1)
         updateOrderDiscount(code, 3, message, title, icon)
         setShow(false)
      } catch (err) {
         console.log(err);
      }
   }

   //update orders temporal discount
   const updateOrderDiscount = async (code, status, message, title, icon) => {
      console.log(code);
      let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      let business = JSON.parse(localStorage.getItem('business'))

      let jsonUpdate = {
         "order_code": code,
         "business_code": business.code,
         "branchoffice_code": branchoffice.code,
         "status": status
      }
      try {
         const response = await DiscountPosFetchAPI.updateOrderTemp(jsonUpdate, token)
         console.log(response);
         ErrorAlert(message, title, icon)
      } catch (err) {
         console.log(err);
      }

   }




   //function to aply cupon
   const aplyCupon = async () => {

      let message = ""
      let title = ""
      let icon = ""
      if (discount > 0) {
         message = "No se pueden aplicar dos descuentos"
         title = "Ya existe un descuento aplicado."
         icon = "warning"
         ErrorAlert(message, title, icon)

      } else {


         let valueUpperCase = valueInput.toUpperCase();
         let arrayInput = valueUpperCase.split("X");
         let codeCupon = arrayInput[1]
         auhtCupon(codeCupon)
      }
   }

   useEffect(() => {

      if (show == true) {
         // Connection with the sockets server


         const socket = Socket({ "business_code": business_code, "branchoffice_code": branchoffice_code, "machine_code": machine.code });
         // we upate the data when the server send the signal of a new order 

         // Escuchar la validación del cupón
         socket.on('cuponValidated', (response) => {

            console.log(response);
            if (response.success) {
               // Mostrar cupón válido
               ErrorAlert("Cupon validado", response.message, "success");
            } else {
               // Mostrar error
               ErrorAlert("Cupón inválido", response.message, "error");
            }

         });

         return () => {
            socket.disconnect();
         }
      }
   }, [show]);

   return (
      <>

         <button className="spn-item" type="button"
            onClick={() => (setShow(true), setSession(getRandomInt(0, 9999)))}>
            <span className="spn-item__ic">
               <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M9 7h6m-6 4h6m-7 9V4a1 1 0 011-1h8a1 1 0 011 1v16l-2-1.5L13 20l-2-1.5L9 20l-1-1z" /></svg>
            </span>
            <span className="spn-item__label">Cupones</span>
         </button>

         <Modal
            show={show}
            size="md"
            onHide={() => setShow(false)}
            aria-labelledby="example-custom-modal-styling-title"
            centered
            dialogClassName="sp-cup-dialog"
            contentClassName="sp-cup-content"
         >
            <Modal.Body className="sp-cup">

               {/* Encabezado */}
               <div className="sp-cup__head">
                  {/* <div className="sp-cup__badge"><i className="uil uil-ticket"></i></div> */}
                  <h4 className="sp-cup__title">{title_modal}</h4>
                  <button className="sp-cup__x" onClick={() => setShow(false)} aria-label="Cerrar" type="button">
                     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                  </button>
               </div>

               {/* QR */}
               <div className="sp-cup__qrwrap">
                  <div className="sp-cup__qr">
                     <QRCode
                        value={JSON.stringify({ business: business_code, branchoffice: branchoffice_code, machine: machine.code, session: session, token: token })}
                        size={300}
                        bgColor="#ffffff"
                        fgColor="#0F1B30"
                        level="H"
                     />
                  </div>
               </div>

               {/* Sesión + instrucción */}
               <div className="sp-cup__session">
                  <span className="sp-cup__session-label">Sesión</span>
                  <span className="sp-cup__session-code" translate="no">{session}</span>
               </div>

               <div className="sp-cup__hint">
                  <i className="uil uil-qrcode-scan"></i>
                  Escanea el QR para aplicar el cupón
               </div>

            </Modal.Body>
         </Modal>


      </>
   )
}

export default ModalCoupons
